export default "__VITE_ASSET__CvAS74PG__"